import { useLayoutEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  buildEvolutionNoteHtml,
  readEvolutionNotePreviewPayload,
} from '../lib/evolutionNoteDocument';

/**
 * Vista previa de nota de evolución en pestaña nueva (HTML imprimible → PDF en el navegador).
 */
export default function AdminEvolutionNotePreview() {
  const payload = useMemo(() => readEvolutionNotePreviewPayload(), []);

  useLayoutEffect(() => {
    if (!payload) return;
    document.title = `Nota de evolución — ${payload.patientName || 'Paciente'}`;
    const html = buildEvolutionNoteHtml(payload);
    document.open();
    document.write(html);
    document.close();
  }, [payload]);

  if (!payload) {
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center gap-4 p-8 text-center">
        <p className="text-muted-foreground">
          No hay datos de la nota para mostrar. Ábrala desde el expediente y pulse Imprimir PDF.
        </p>
        <Link to="/admin/expedientes" className="text-primary underline">
          Volver a expedientes
        </Link>
      </div>
    );
  }

  return (
    <p className="p-8 text-center text-muted-foreground">
      Cargando documento… Si no aparece, use el botón Imprimir en la barra superior.
    </p>
  );
}
